import { Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { ContractOrigin } from "../../enums";

const getData = (item: ContractOrigin) => {
  switch (item) {
    case ContractOrigin.TYPED:
      return { color: PresetColors.MAGENTA, shortLabel: "NA" };
    case ContractOrigin.CALC:
      return { color: PresetColors.GEEKBLUE, shortLabel: "KA" };
    case ContractOrigin.IMPORT:
      return { color: PresetColors.LIME, shortLabel: "IM" };
    case ContractOrigin.MANUAL_IMPORT:
      return { color: PresetColors.DEFAULT, shortLabel: "MA" };
    case ContractOrigin.EUCS:
      return { color: PresetColors.GREEN, shortLabel: "EU" };
    case ContractOrigin.IAD:
      return { color: PresetColors.CYAN, shortLabel: "IA" };
    case ContractOrigin.IBIS:
      return { color: PresetColors.GOLD, shortLabel: "IB" };
    case ContractOrigin.LUNA:
      return { color: PresetColors.BLUE, shortLabel: "LU" };
    case ContractOrigin.MONLY:
      return { color: PresetColors.PURPLE, shortLabel: "MO" };
    case ContractOrigin.NN:
      return { color: PresetColors.ORANGE, shortLabel: "NN" };
    default:
      throw new Error(`Unexpected value: ${item satisfies never}`);
  }
};

type Props = {
  origin: ContractOrigin;
  isWide?: boolean;
};

export const ContractOriginTag = ({ origin, isWide }: Props) => {
  const { t } = useTranslation();

  const data = getData(origin);

  return (
    <Tooltip title={`${t("contract.helpers.originValue")}: ${t(`contract.enums.contractOrigin.${origin}`)}`}>
      <Tag color={data.color}>{isWide ? t(`contract.enums.contractOrigin.${origin}`) : data.shortLabel}</Tag>
    </Tooltip>
  );
};
